import * as React from "react";
import { cn } from "@workspace/ui/lib/utils";

function ScreenHeightDiv({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="screen-height-div"
      className={cn(
        // Multi-browser height fallbacks based on Stack Overflow solution
        // https://stackoverflow.com/questions/54175400/how-to-use-height-webkit-fill-available-in-edge-browser-how-to-make-a-div-fil
        "h-[calc(100vh-74px)]", // Fallback for older browsers
        "h-[calc(100dvh-74px)]", // Modern browsers with dynamic viewport
        "[height:-moz-available]", // Firefox
        "[height:-webkit-fill-available]", // WebKit browsers (Safari, Chrome)
        "[height:fill-available]", // Standard (future)
        // Smooth transitions for viewport changes
        "transition-[height] duration-300 ease-out",
        className,
      )}
      {...props}
    />
  );
}

export { ScreenHeightDiv };
